const ja = {
  contactSupport: {
    title: "コンタクトサポート",
    content: ["質問したいことはありますか？", "このメールアドレスにお問い合わせください。"],
    button: "o k",
    download_tips: "このアプリはまだオンラインになっていません。もう少しお待ちください",
  },
  selectLanguage: {
    title: "言語・通貨",
    titleLanguage: "言語",
    titleCurrency: "通貨",
    headerTitle: "言語・通貨",
    hint: "お好みに応じて言語を設定することができますので、より簡単にご利用いただけます。",
    button: "環境設定の保存",
    language: "使用言語",
    currency: "使用通貨",
  },
  meau: ["テクノロジーのドキュメント", "プロダクトのドキュメント"],
  banner: {
    list: [
      {
        title1: "Loot Bar: ",
        title2: "世界的に流行ゲームアイテム取引モール！",
        essay:
          "Loot Barは世界的に流行するゲームアイテム取引モールです。Loot Barの中で、素早くお気に入りのアイテムを購入できます。全力的素晴らしい体験を捧げますので、是非ご利用してください！",
        btn: "アプリをダウンロード！",
      },
      {
        title: "更なる市場開発",
        essay: "健全な取引市場を通し、ユーザー数上昇とトラフィック誘導を実現します",
      },
      {
        title: "他ゲームからの流動",
        essay:
          "数多くのユーザーを誇る当プラットフォームでキャンペーンを行い、新規ユーザーの増加と売上アップにつなげましょう",
      },
    ],
    button: "今すぐお申し込み",
  },

  introduce: {
    title: "弊社プラットフォームの特徴",
    essay:
      "ゲームの取引市場と制度の規範を確立し、より良い資産環境を提供しております。そしてアクティブなユーザーを増やし、継続した発展を後押しします",
  },
  partner: {
    title: "集積試合",
  },
  contact: {
    title: "貴社のゲームに新たな成長を提供",
    essay: "貴社ゲームがより良い市場を提供できるよう注力しており、ゲームの健全な発展を手助けします",
    hint: "私たちと一緒にいてください、あなたのゲームは改善し続けます",
    form: {
      title: "専門家に連絡する",
      hint: "私たちはあなたのニーズについて学ぶことを楽しみにしています",
      button: "リクエストを作成",
    },
    input: [
      {
        placeholder: "Eメール",
        error: "Eメールを入力してください",
      },
      {
        placeholder: "会社",
        error: "会社名を入力してください",
      },
    ],
  },
  contactForm: {
    title: "どのようなご用件でしょうか？",
    hint: "最低1つ選択してください。",
    download_tips: "このアプリはまだオンラインになっていません。もう少しお待ちください",
    inputList: {
      list: [
        { placeholder: "苗字", error: "Please enter your first name." },
        { placeholder: "名称", error: "Please enter your last name." },
        { placeholder: "あなたの役職をお書きください", error: "Please select your role." },
      ],

      selectList: [
        { name: "CEO/エグゼクティブ/ファウンダー", translate: "首席执行官/执行总裁/创始人" },
        { name: "ゲーム開発者/プログラマー", translate: "游戏开发者/程序员" },
        { name: "マーケター", translate: "营销人员" },
        { name: "ビジネスデベロッパー", translate: "业务开发员" },
        { name: "プロダクトマネージャー", translate: "产品经理" },
        { name: "ファイナンス/ペイメント", translate: "金融与支付" },
        { name: "オペレーション/マネタイズ", translate: "运营/货币化" },
        { name: "ファイナンス＆ペイメント", translate: "金融与支付" },
        { name: "オペレーション/マネタイゼーション", translate: "运营/货币化" },
        { name: "プロデューサー", translate: "生产者" },
        { name: "その他", translate: "其他" },
      ],
    },
    checkList: {
      list: [
        "製品の新たな成長軌道を期待しています",
        "トレーディング・プラットフォームとの連携に期待",
        "不明",
      ],
      error: "1つ以上のオプションを選択してください",
    },
    lastForm: {
      list: [
        { placeholder: "お客様のビジネスサイト", error: "御社のホームページを入力してください。" },
        { placeholder: "従業員数", error: "従業員数を入力してください。" },
        { placeholder: "あなたのゲーム名", error: "ゲーム名を入力してください。" },
        {
          placeholder: "どのようにして弊社をお知りになりましたか？*",
          error: "一つ選択してください。",
        },
      ],

      selectList: [
        { name: "オンライン広告", translate: "在线广告" },
        { name: "印刷広告", translate: "印刷广告" },
        { name: "紹介", translate: "推荐人" },
        { name: "検索", translate: "搜索" },
        { name: "プレス・ニュース", translate: "媒体/新闻" },
        { name: "ソーシャル・メディア", translate: "社会媒体" },
        { name: "その他", translate: "其他" },
      ],
    },
    button: {
      back: "前の項目",
      submit: "次の項目",
    },
    success: {
      title: "ありがとうございました",
      hint: "リクエストは正常に送信されました。追ってご連絡いたします。",
      button: "完了",
    },
  },
  modalSuccess: {
    title: "ありがとうございました",
    essay: "リクエストは正常に送信されました。  追ってご連絡いたします。",
    button: "完了",
  },
};

export default ja;
